import OeeDial from "./OeeDial"
import { useAppDispatch } from '../../../app/hooks'
import { Card } from "../../../CardFactory"
import OeePrimaryDial from "./OeePrimaryDial"
import { DataPie20Regular } from "@fluentui/react-icons";
import { OeeData, GetOeeData } from "../../../services/OeeService"
import { loadAttributes } from "../../../Slices/AttributesSlice"
import { useEffect, useState } from "react"
import { removeCard } from "../../../Slices/DashboardSlice";
import { CardHeader } from "../Machine/CardHeader";
import { CollapseTop } from "../Machine/CollapseTop";
import { CollapsableSection } from "../Machine/CollapsableSection";
import { CardProps } from "../CardProps";

export function OeeCard(cardProps: CardProps) {
    const [oeeData, setOeeData] = useState({} as OeeData);
    const [timeSpan, setTimeSpan] = useState(8);
    const [title, setElementsTitle] = useState("");

    const [oeeMainExpanded, setOeeMainExpanded] = useState(true);
    const [oeeElementsExpanded, setOeeElementsExpanded] = useState(false);
    const dispatch = useAppDispatch();

    const Dismiss = () => {
        cardProps.onDismiss && cardProps.onDismiss();
    }

    const icon = <DataPie20Regular />;

    useEffect(() => {
        (async () => {
            const data = await GetOeeData(cardProps.elementGuid);


            data && setOeeData(data);
            data && dispatch(loadAttributes
                ({
                    elementGuid: cardProps.elementGuid,
                    attributeGuid: data.MajorOee.OeeGuid,
                    hoursStarting: 168
                })
            );

            if (data) {
                const elementsTitle =
                    cardProps.name === ""
                        ? oeeData.Key
                        : cardProps.name === " "
                            ? " "
                            : cardProps.name + " / " + (oeeData.OeeType === "WC" ? "GROUPS" : "MACHINES");

                setElementsTitle(elementsTitle);
            }

            data && data.MinorOee?.forEach((MinorOee) => {
                dispatch(loadAttributes
                    ({
                        elementGuid: MinorOee.ElementGuid,
                        attributeGuid: MinorOee.OeeGuid,
                        hoursStarting: 0
                    })
                );
            });
        })();
    }, [cardProps.elementGuid, dispatch]);



    const Main = () => {
        return <>
            <div className="p-2">
                <OeePrimaryDial  {...{ OeeGuid: oeeData?.MajorOee?.OeeGuid, timeSpan: timeSpan }} />
            </div>
        </>
    }

    const Elements = () => {
        return <div className="grid grid-cols-[repeat(auto-fill,minmax(80px,1fr))]
        gap-6 pt-5 pb-6 px-4">
            {oeeData.MinorOee?.map((MinorOee) => {
                return (
                    <OeeDial key={MinorOee.ElementGuid} title={MinorOee.ElementName} alias={MinorOee.Alias} attributeGuid={MinorOee.OeeGuid} value={0} />
                )
            })}
        </div>
    }

    return (
        <div
            className=" bg-primary-light bg-primary border-border-light dark:bg-primary-dark dark:border-border-dark border-1 drop-shadow-lg"
            data-tour={`card-oee-${cardProps.elementGuid}`}
        >

            <CardHeader title={"OEE"} subtitle={cardProps.name} onClick={Dismiss} icon={icon} />
            <div className="py-2 space-y-2 pt-5">
                <CollapseTop title={cardProps.name} expand={() => { setOeeMainExpanded(!oeeMainExpanded) }} rightValueUnderline={true} startsExpanded={true} />
                <CollapsableSection expanded={oeeMainExpanded} children={<Main />} />

                <CollapseTop title={title} expand={() => { setOeeElementsExpanded(!oeeElementsExpanded) }} />
                <CollapsableSection expanded={oeeElementsExpanded} children={<Elements />} />
            </div>

        </div>
    )
}

export default (OeeCard)